import { useQuery } from '@tanstack/react-query';
import { fetchAdminIssues, type AdminIssuesFilters, type AdminIssuesResult } from '../api/adminIssuesApi';
import { samePopulation } from '../utils/samePopulation';

export const adminIssuesQueryKey = (filters: AdminIssuesFilters) => ['adminIssues', filters];

export const useAdminIssues = (filters: AdminIssuesFilters) =>
  useQuery<AdminIssuesResult>({
    queryKey: adminIssuesQueryKey(filters),
    queryFn: () => fetchAdminIssues(filters),
    enabled: !!filters.serviceDeskId,
    /**
     * ⚠️ Previous rows are kept for a page turn (`pageToken`), and for nothing else: react-query
     * holds `isLoading` at false while a placeholder stands, so keeping it unconditionally left the
     * previous desk's tickets in the table — under the new desk's name in the picker and the URL,
     * with no loader to say otherwise.
     */
    placeholderData: (previous: AdminIssuesResult | undefined, previousQuery) =>
      samePopulation('pageToken', previousQuery?.queryKey?.[1] as AdminIssuesFilters | undefined, filters)
        ? previous
        : undefined,
    staleTime: 30_000,
  });
